/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Edit_PcInputs */

const en_pc_cmp_r_edit_pc = /** @type {(inputs: Pc_Cmp_R_Edit_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not reliable yet, on the roadmap`)
};

const zh_pc_cmp_r_edit_pc = /** @type {(inputs: Pc_Cmp_R_Edit_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚不稳定，已列入路线图`)
};

/**
* | output |
* | --- |
* | "Not reliable yet, on the roadmap" |
*
* @param {Pc_Cmp_R_Edit_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_edit_pc = /** @type {((inputs?: Pc_Cmp_R_Edit_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Edit_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_edit_pc(inputs)
	return zh_pc_cmp_r_edit_pc(inputs)
});
export { pc_cmp_r_edit_pc as "pc.cmp.r.edit.pc" }